import { AssigneeHeader } from "../../../../../../components/AssigneeHeader";
import React from "react";
import { t } from "i18next";
import { Text } from "@chakra-ui/react";

function MissingCategory({ assignee, data }) {
  return (
    <>
      <AssigneeHeader
        assignee={assignee}
        period={data.period}
      />
      <Text fontSize="lg" fontWeight="bold">
        {t("reportsPage.typeNotSelected")}
      </Text>
    </>
  );
}

export default MissingCategory;